import {createRouter, createWebHistory} from 'vue-router'
import Dashboard from '../views/Dashboard'
import ViewApplication from '../views/Application/Index'
import ReviewApplication from '../views/Application/Review'
import EditApplication from '../views/Application/Edit'
import EditApplicationForm from '../views/Application/EditForm'
import RefereePortal from '../views/RefereePortal/Index'
import Register from '../views/Auth/Register'
import Users from '../views/Users'
import Login from '../views/Auth/Login'
import Logout from '../views/Auth/Logout'
import ProfilePage from '../views/ProfilePage/Index'
import OfferDecision from '../views/Application/Details/OfferDecision'
import VerifyEmail from '../views/VerifyEmail'
import VerificationRequired from '../views/VerifyEmail/VerificationRequired'
import ForgotPassword from '../views/ProfilePage/forgotPassword'
import ResetPassword from '../views/ProfilePage/resetPassword'
import EditReferees from '../views/Application/EditReferees'
import EditChoices from '../views/Application/EditChoices'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Dashboard,
    },
    {
        path: '/email-verification-needed',
        name: 'emailVerificationNeeded',
        component: VerificationRequired,
    },
    {
        path: '/verify-email/:hash',
        name: 'Verify Email',
        component: VerifyEmail,
    },
    {
        path: '/applications',
        name: 'ViewApplication',
        component: ViewApplication,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/applications/:id/Review',
        name: 'ReviewApplication',
        component: ReviewApplication,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/applications/:id/Edit',
        name: 'EditApplication',
        component: EditApplication,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/applications/:id/EditForms',
        name: 'EditModuleApplication',
        component: EditApplicationForm,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/applications/:id/EditReferees',
        name: 'EditReferees',
        component: EditReferees,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/applications/:id/EditChoices',
        name: 'EditChoices',
        component: EditChoices,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/applications/:id/Decision',
        name: 'ApplicationDecision',
        component: OfferDecision,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            requiresVisitor: true,
        },
    },
    {
        path: '/logout',
        name: 'Logout',
        component: Logout,
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        meta: {
            requiresVisitor: true,
        },
    },
    {
        path: '/referee_portal/:id/:token',
        name: 'Referee Portal',
        component: RefereePortal,
    },

    {
        path: '/profile',
        name: 'Profile',
        component: ProfilePage,
    },
    {
        path: '/forgotPassword',
        name: 'Forgot Password',
        component: ForgotPassword,
        meta: {
            requiresVisitor: true,
        },
    },
    {
        path: '/resetPassword/:id/:token',
        name: 'Reset Password',
        component: ResetPassword,
        meta: {
            requiresVisitor: true,
        },
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

export default router
